<template>
  <dd
    :class="['text-base font-normal text-gray-500 mt-1', className] | twMerge"
    :style="style"
  >
    <template v-if="withSlotLoading && isLoading">
      <slot name="slotLoading" />
    </template>
    <div v-else-if="isLoading">
      <Skeleton className="w-52 h-5 rounded-md" />
    </div>
    <slot v-else />
  </dd>
</template>

<script>
import Skeleton from '@/components/ui/Skeleton';

export default {
  name: 'DescriptionDetail',
  components: {
    Skeleton
  },

  props: {
    className: [String, Array],
    isLoading: Boolean,
    withSlotLoading: Boolean,
    style: [String, Object, Array]
  }
}
</script>
